import { NextPageContext } from 'next'
import { isSubdomainMatches } from '@ucheba/utils/middlewares/defineLocationMiddleware'
import { Store } from 'redux'
import { pageDataOfferThunks } from '@ucheba/store/page-data/offer'
import { clientProductsTariffsThunks } from '@ucheba/store/client-products/tariffs'
import { pageDataAboutPlatformThunks } from '@ucheba/store/page-data/about-platform'
import { sendRequest } from '@ucheba/utils/helpers/api'
import { pageDataHeaderOffersThunks } from '@ucheba/store/page-data/for-abiturients/headerOffers'
import IndexEgePage from './index'
import { headerActions } from '../../../components/Header/store'
import { footerActions } from '../../../components/Footer/store'
import { footerNavSchoolLinks } from '../school/index/constants'

IndexEgePage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store, query } = ctx
  const { dispatch } = store
  const isDomainWWW = isSubdomainMatches(ctx.req, store, 'www')

  const canonical = isDomainWWW ? undefined : 'https://www.ucheba.ru/for-abiturients/ege'

  dispatch(footerActions.setColor('black'))
  dispatch(headerActions.toggleHeader(false))
  dispatch(footerActions.setNavLinks(footerNavSchoolLinks))

  if (query.offer) {
    await dispatch(pageDataHeaderOffersThunks.fetch({ ctx }))
  }
  await dispatch(pageDataOfferThunks.fetch({ ctx }))
  await dispatch(clientProductsTariffsThunks.fetch({ ctx }))
  await dispatch<any>(pageDataAboutPlatformThunks.fetch({ ctx }))

  const response = await sendRequest({ url: '/page_data/school_page', ctx })

  const data = response?.data

  if (!data) {
    return {
      notFound: true,
    }
  }

  return {
    canonical,
    data,
  }
}

export default IndexEgePage
